import ApiService from './ApiService'

export async function apiGetReferralSponsor(data) {
    return ApiService.fetchData({
        url: '/sponsor/get',
        method: 'post',
        data,
    })
}